import { Route, Routes } from 'react-router-dom';
import CompanyDashboard from '../pages/company/dashboard';
import CompanyRoles from '../pages/company/roles/roles';
import Branches from '../pages/company/branch/branch';
import AddEditBranch from '../pages/company/branch/branch_form';
import BranchUser from '../pages/company/users/users';
import AddEditBranchUser from '../pages/company/users/users_form';
import SupplierList from '../pages/company/supplier/supplier';
import AddEditSupplier from '../pages/company/supplier/supplier_form';
import AccoutingSetup from '../pages/company/purchases/accouting-setup';
import AddPurchases from '../pages/company/purchases/add_purchases';
import Purchases from '../pages/company/purchases/purchases';
import Taxes from '../pages/company/purchases/partials/taxes';
import Units from '../pages/company/purchases/partials/units';
import Products from '../pages/company/products/products';
import PurchasesStock from '../pages/company/purchases/purchases_stock';
import CompanyTenders from '../pages/company/tenders/tenders';
import CompanyCustomer from '../pages/company/customers/customer';
import PurchasesProducts from '../pages/company/purchases/purchases_product';
import FinalCategories from '../pages/company/categories/FinalCategory';
import PurchaseRequest from '../pages/company/purchases/pushed_purchase';
import ApprovedPurchases from '../pages/company/purchases/approved_purchases';
import RawMaterialStockScreen from '../pages/company/raw_material/raw_material';
import BillsProducts from '../pages/company/billls/bills';
import CreditNotes from '../pages/company/billls/credit_note';
import AssetsPage from '../pages/company/assets/assets';
import ExpensesPage from '../pages/company/expenses/expenses';
import PermissionPage from '../pages/company/roles/permission';
import TaskFormCreate from '../pages/company/task/task_form';
import TaskAssignedUser from '../pages/company/task/task_users';
import TaskAssigned from '../pages/company/task/task_assigned';
import PosPage from '../pages/company/pos/Pos';
import ProductAttributePage from '../pages/company/productAttributes/productAttributes';
import Brands from '../pages/company/brands/brands';
import ImportPage from '../pages/company/import_export/import';
import ExportPage from '../pages/company/import_export/export';
import ImportHistoryPage from '../pages/company/import_export/import_history';
import PurchaseImportPage from '../pages/company/import_export/purchase_import';
import IdealStockImportPage from '../pages/company/import_export/ideal_stock_import';
import StockRemovePage from '../pages/company/import_export/stock_remove';
import SalesBillsPage from '../pages/company/billls/sales_bills';
import CompanyProfile from '../pages/company/profile';
import CamScannerPage from '../pages/company/camscanner';
import SalesReport from '../pages/company/reports/sales_report';
import StockReport from '../pages/company/reports/stock_report';
import SupplierPayment from '../pages/company/supplier/supplier_payment';
import OtherReports from '../pages/company/otherReports';
import ReportDetails from '../pages/company/report_detail';
import ClaimBills from '../pages/company/billls/claim_bills';
import TallyConnectionGuide from '../pages/company/tally_guide';
import CompanyLocation from '../pages/company/locations/company_location';
import CompanyWarehouse from '../pages/company/warehouse/warehouse';
import CompanyCurrency from '../pages/company/currencies/company_currency';
import CompanyMetalRate from '../pages/company/metalRate/metal_rate';
import CompanyHrmsSetup from '../pages/company/hrms_setup/hrmsSetup';
import SetSalary from '../pages/company/hrms_setup/setupSalary';
import CompanySetup from '../pages/company/company_setup/companySetup';
import Accounting from '../pages/company/accounting/accounting';
import SalesCreditNote from '../pages/company/sales_credit/SalesCreditNote';
import DueSalesBillsPage from '../pages/company/billls/due_bills';
import DispensingMaster from '../pages/company/dispensing_master/dispensing_master';
import DispensingMaterials from '../pages/company/dispensing_materials/dispensing_materials';
import ArrangeDuplicatesPage from '../pages/company/products/arrange_duplicate';
import TransferLogsPage from '../pages/company/products/transfer_logs';


const CompanyRoutes = () => {
  return (
    <Routes>  {/* Wrap your routes with <Routes> */}

      <Route path="/" element={<CompanyDashboard />} />
      <Route path="/company-setup" element={<CompanySetup />} />
      <Route path="/dashboard" element={<CompanyDashboard />} />
      <Route path="/reports" element={<OtherReports />} />
      <Route path="/reports/:id" element={<ReportDetails />} />
      <Route path="/profile" element={<CompanyProfile />} />
      <Route path="/pos" element={<PosPage />} />
      <Route path='/roles' element={<CompanyRoles />} />
      <Route path='/permissions' element={<PermissionPage />} />
      <Route path='/branch' element={<Branches />} />
      <Route path='/branch/add' element={<AddEditBranch />} />
      <Route path='/branch/edit' element={<AddEditBranch />} />
      <Route path='/branch/users' element={<BranchUser />} />
      <Route path='/branch/users/add' element={<AddEditBranchUser />} />
      <Route path='/branch/users/edit' element={<AddEditBranchUser />} />
      <Route path='/suppliers' element={<SupplierList />} />
      <Route path='/suppliers/add' element={<AddEditSupplier />} />
      <Route path='/suppliers/edit' element={<AddEditSupplier />} />
      <Route path='/setup/*' element={<AccoutingSetup />}>
        <Route path='taxes' element={<Taxes />} />
        <Route path='units' element={<Units />} />
      </Route>
      <Route path='/import' element={<ImportPage />} />
      <Route path='/import/ideal-stock' element={<IdealStockImportPage />} />
      <Route path='/import/stock-remove' element={<StockRemovePage />} />
      <Route path='/import/purchases' element={<PurchaseImportPage />} />
      <Route
        path="/import/images"
        element={<CamScannerPage />} />
      <Route path="/payment/supplier" element={<SupplierPayment />} />
      <Route path="/reports/sales" element={<SalesReport />} />
      <Route path="/reports/stock" element={<StockReport />} />
      <Route path='/import/history' element={<ImportHistoryPage />} />
      <Route path='/export' element={<ExportPage />} />
      <Route path='brands' element={<Brands />} />
      <Route path='product-attributes' element={<ProductAttributePage />} />
      <Route path='/raw-products' element={<Purchases />} />
      <Route path='/raw-products-stock' element={<RawMaterialStockScreen />} />
      <Route path='/raw-product/stock' element={<PurchasesStock />} />
      <Route path='/raw-product/purchases' element={<PurchasesProducts />} />
      <Route path='/products' element={<Products />} />
      <Route path='/arrange-duplicate' element={<ArrangeDuplicatesPage />} />
      <Route path='/transfer-logs' element={<TransferLogsPage />} />
      <Route path='/categories' element={<FinalCategories />} />
      <Route path='/customers' element={<CompanyCustomer />} />
      <Route path='/tenders/:type' element={<CompanyTenders />} />
      <Route path='/pushed-purchase' element={<PurchaseRequest />} />
      <Route path='/approved-purchase' element={<ApprovedPurchases />} />
      <Route path='/accounts/bills' element={<BillsProducts />} />
      <Route path='/accounts/sales-bills' element={<SalesBillsPage />} />
      <Route path='/accounts/due-bills' element={<DueSalesBillsPage />} />
      <Route path='/accounts/claimed-bills' element={<ClaimBills />} />
      <Route path='/accounts/credit-notes' element={<CreditNotes />} />
      <Route path='/accounts/assets' element={<AssetsPage />} />
      <Route path='/accounts/expenses' element={<ExpensesPage />} />
      <Route path='/task/:type' element={<TaskFormCreate />} />
      <Route path='/task/:type' element={<TaskFormCreate />} />
      <Route path='/task/assigned-to-you' element={<TaskAssigned />} />
      <Route path='/task/assigned-by-you' element={<TaskAssignedUser />} />
      <Route path='/tally/guide' element={<TallyConnectionGuide />} />
      <Route path='/locations' element={<CompanyLocation />} />
      <Route path='/warehouse' element={<CompanyWarehouse />} />
      <Route path='/currencies' element={<CompanyCurrency />} />
      <Route path='/metal-rates' element={<CompanyMetalRate />} />
      <Route path='/hrms-setup' element={<CompanyHrmsSetup />} />
      <Route path='/set-salary' element={<SetSalary />} />
      <Route path='/accounting' element={<Accounting />} />
      <Route path='/sales-credit-notes' element={<SalesCreditNote />} />
      <Route path='/dispensing-master' element={<DispensingMaster />} />
      <Route path='/dispensing-materials' element={<DispensingMaterials />} />

    </Routes>
  );
};

export default CompanyRoutes;
